import type { MsgDeskLoadingProps } from '@/deskUiSkeletons/Shared/SharedSurfaceContext'

export function MsgDeskLoading({ contract, label = 'Loading Wiki', className = '' }: MsgDeskLoadingProps) {
  const legacyEditorLoading = contract === 'editor.loading'
  return (
    <div
      data-md-contract={contract}
      className={`${legacyEditorLoading ? 'hidden ' : ''}flex min-h-24 items-center justify-center text-sm text-slate-500 ${className}`}
    >
      {label}
    </div>
  )
}
